// @flow

import React from "react";

import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";
import * as formatters from "../../utils/formatters";

import {
  FINANCING_PRODUCT,
  AMOUNT,
  FINANCING_OWN_FOUNDS,
  FINANCING_DEMAND,
  FINANCING_SUPPORT,
  PRODUCT_KIND_DESCRIPTION
} from "./formFields";
import { mapFinancingProduct, mapSupport } from "./mappers";

import { type FinancingSectionProps } from "../../types/details";

const FinancingMicroMezzanineEnterpriser = ({
  initialValues,
  handleSubmit,
  isLocked,
  site
}: FinancingSectionProps) => {
  return (
    <EditableForm initialValues={initialValues} onSubmit={handleSubmit} isLocked={isLocked}>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: FINANCING_SUPPORT,
            caption: () => "Unterstützung durch einen Experten"
          }}
          displayValue={mapSupport(site === "customer")}
        />
        <EditableField
          fieldControlProps={{
            name: FINANCING_PRODUCT,
            caption: () => "Finanzierungsart"
          }}
          displayValue={mapFinancingProduct}
        />
        <EditableField
          fieldControlProps={{
            name: PRODUCT_KIND_DESCRIPTION,
            caption: () => "Beschreibung"
          }}
        />
      </FormRow>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: AMOUNT,
            caption: () => "Investitionskosten"
          }}
          displayValue={formatters.formatCurrency}
        />
        <EditableField
          fieldControlProps={{
            name: FINANCING_OWN_FOUNDS,
            caption: () => "Eigenmittel"
          }}
          displayValue={formatters.formatCurrency}
        />
        <EditableField
          fieldControlProps={{
            name: FINANCING_DEMAND,
            caption: () => "Finanzierungsbedarf"
          }}
          displayValue={formatters.formatCurrency}
        />
      </FormRow>
    </EditableForm>
  );
};

export default FinancingMicroMezzanineEnterpriser;
